/**
 * This module is in charge of updating the queryString value by reacting to user interactions with the search filters.
 */
import { store$, store } from '@redux/store';
import { map, distinctUntilChanged, filter, skip } from 'rxjs/operators';
import { routingStateActions } from 'features/routing';
import { ResultType } from 'features/searchResultsFacets';
import LoadingStatus from 'enums/loadingStatus';
import { selectCountsAndQueryString } from '../redux/selectors';
import { onQueryStringChanged$ } from '../redux/observables';

/**
 * updateQueryString: dispatches an action to the routing state in order to store a new query string.
 */
const onUpdateQueryString = (queryString) => {
  setTimeout(() => {
    store.dispatch(routingStateActions.updateQueryString(queryString));
  }, 0)
}

/**
 * This observable will stream any time there are new results in the Search Results Page.
 */
const onNewResults$ = store$.pipe(
  map(selectCountsAndQueryString),
  filter(({ resultCountsStatus }) => 
    resultCountsStatus.name === LoadingStatus.Succeeded.toString()),
  distinctUntilChanged(),
  map(({ queryString, resultType, listingCounts, minimumRequiredFiltersQueryString }) => {
    if (resultType === ResultType.Builders.toString()) {
      return minimumRequiredFiltersQueryString;
    }

    if (listingCounts === 0) {
      return minimumRequiredFiltersQueryString;
    }

    return queryString;
  }),
);

onNewResults$.subscribe(onUpdateQueryString);

onQueryStringChanged$.pipe(
  skip(1),
).subscribe(onUpdateQueryString);